import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import StockList from "./component/StockList";
import NotFound from "./component/NotFound";
import Navbar from "./component/Navbar/Navbar";
import BuySellSignal from "./component/BuySellSignal";
import OperationRecords from "./component/List/OperationRecords";

function App() {
  return (
    <>

      <Router>
        <div className="App">
          <Navbar />

          <Routes>
            <Route path="/" element={<StockList />} />
            <Route path="/buy-sell-signal" element={<BuySellSignal />} />
            <Route path="/records" element={<OperationRecords />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </Router>

    </>
  );
}

export default App;
